import BaseRequest from './BaseRequest';

const schema = 'favorite';
/**
 * key base on host:port
 */
export default class FavoritesRequest extends BaseRequest {
  /**
	 *
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchFavorites(params) {
    const url = `${schema}/`;
    return this.get(url, params);
  }

  updateFavorites(params) {
    const url = `${schema}/${params.coin}/${params.currency}`;
    return this.post(url);
  }

  deleteFavorites(params) {
    const url = `${schema}/${params.coin}/${params.currency}`;
    return this.del(url);
  }
}
